export default {
  // Este componente não tem strings traduzíveis estáticas
  // Usa dados dinâmicos passados de props
}
